import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

export class GgCustomFormValidators {
  static passwordValidator(control: AbstractControl): ValidationErrors | null {
    // const PASSWORD_PATTERN = /^.{8,}$/;
    const PASSWORD_PATTERN = /^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[!@#$%^*()_\-+{};:.,&"€\/=?]).{8,}$/;
    const password = control.value as string;

    return password && (!password.length || password.match(PASSWORD_PATTERN)) ? null : { cxInvalidPassword: true };
  }

  static phoneNumberValidator(control: AbstractControl, baseSiteId: string, environment: any): ValidationErrors | null {
    const phoneNumber = control.value as string;
    return (phoneNumber &&
      (!phoneNumber.length ||
        new RegExp('(' + environment.formValidators.phoneNumber[baseSiteId] + ')$', 'y').exec(phoneNumber))) ||
      !environment.formValidators.phoneNumber[baseSiteId]
      ? null
      : { cxInvalidPhoneNumber: true };
  }

  static postalCodeValidator(control: AbstractControl, baseSiteId: string, environment: any): ValidationErrors | null {
    const postalCode = control.value as string;

    return (postalCode &&
      (!postalCode.length ||
        new RegExp('(' + environment.formValidators.postalCode[baseSiteId] + ')$', 'y').exec(postalCode))) ||
      !environment.formValidators.postalCode[baseSiteId]
      ? null
      : { cxInvalidPostalCode: true };
  }

  static numberValidator(control: AbstractControl): ValidationErrors | null {
    const number = control.value as string;

    return number && (!number.length || /^[0-9]*$/.exec(number)) ? null : { cxInvalidNumber: true };
  }

  static productRecallSerialNumberValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value as string;

    return value && (!value.length || /^.{23}$/.test(value)) ? null : { cxInvalidSerialNumber: true };
  }

  static atLeastOneCheckedValidator(control: AbstractControl): ValidationErrors | null {
    if (!(control instanceof FormGroup)) {
      throw new Error('atLeastOneCheckedValidator should be used on a FormGroup.');
    }

    const controls = control.controls;
    const hasAtLeastOneChecked = Object.keys(controls).some((key) => controls[key].value === true);

    return hasAtLeastOneChecked ? null : { atLeastOneChecked: true };
  }
}
